module.exports = __webpack_public_path__ + "img/Custom Dashboard.ab10f7f1.svg";